export default {
    createYourFirstInvoice: '最初の請求書をつくる',
    information: {
        subtitle:
            'こちらはあなたが取引先に送る書類に表示される送付者情報のプレビューです。',
        title: '請求書をつくるための準備ができました！',
    },
    pageForm: {
        addInvoicingContract: '別の連絡先を追加する',
        senderInformationFullButtonLabel: '住所形式を外国式表記へ変更する',
        senderInformationFullLabel: '書類にこの連絡先を表示する',
        subtitle:
            '入力情報は正しいですか？この設定は後からいつでも変更可能です。',
        title: '書類に表示する連絡先のプレビュー',
    },
    senderInformation: {
        businessNameAndThisContact: '書類にこの連絡先を表示する',
        businessNameOnly: '書類に社名のみを表示する',
        delete: '削除',
        edit: '編集',
        enChangeTo: '住所形式を日本式表記へ変更する',
        fax: 'FAX {{fax}}',
        jaChangeTo: '住所形式を外国式表記へ変更する',
        telephone: 'TEL {{telephone}}',
    },
};
